import React from 'react'
import PropTypes from 'prop-types'

import {
  BannerContainer,
  TextContainer,
  SubLabel,
  Disclosure,
  PromoHeader,
  DiscountText,
  StyledText,
  DisclosureTextContainer,
} from './styles'

export const BfcmPdpBanner = ({
  promoHeader,
  promoSubHeader = {},
  disclaimerText1,
  disclaimerText2,
  discountText,
  discountTextColor,
  promoBannerBkgdColor,
}) => {
  const { preStyledText, styledText, postStyledText, styledTextColor } = promoSubHeader

  return (
    <BannerContainer promoBannerBkgdColor={promoBannerBkgdColor}>
      <TextContainer>
        <PromoHeader>{promoHeader}</PromoHeader>
        <DiscountText color={discountTextColor}>{discountText}</DiscountText>
        {promoSubHeader && (
          <SubLabel>
            {preStyledText}
            <StyledText styledTextColor={styledTextColor}>{styledText}</StyledText>
            {postStyledText}
          </SubLabel>
        )}
        <DisclosureTextContainer>
          <Disclosure>{disclaimerText1}</Disclosure>
          {disclaimerText2 && <Disclosure>{disclaimerText2}</Disclosure>}
        </DisclosureTextContainer>
      </TextContainer>
    </BannerContainer>
  )
}

BfcmPdpBanner.propTypes = {
  promoHeader: PropTypes.string.isRequired,
  promoSubHeader: PropTypes.object,
  disclaimerText1: PropTypes.string.isRequired,
  disclaimerText2: PropTypes.string,
  discountTextColor: PropTypes.string.isRequired,
  promoBannerBkgdColor: PropTypes.string.isRequired,
  discountText: PropTypes.string.isRequired,
}
